import { Button, Card, Icon, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { Thread } from 'api/bulletinBoard/bulletinBoard.api'
import classNames from 'classnames'
import React, { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Like from './components/Like'
import GeneralPost from './GeneralPost/GeneralPost'
import BulletinBoardTextField from './TextField/TextField'
import styles from './Thread.module.less'

type BulletinBoardThreadProps = {
  thread: Thread
}

export default function BulletinBoardThread({ thread }: BulletinBoardThreadProps): ReactElement {
  const { t } = useTranslation()

  const [showComments, setShowComments] = useState(false)
  const handleOnClick = (commentShow: boolean): void => {
    setShowComments(commentShow)
  }
  const commentCount = Object.keys(thread.comments).length

  const postHasCommentsTitle = `${t(`The post has `)} ${commentCount}
  ${commentCount > 1 ? t(`comments`) : t(`comment`)}`

  return (
    <Grid container sx={{ flexGrow: 1 }}>
      <Card className={styles.Thread_Thread}>
        <GeneralPost post={thread} />
        <Grid container direction="row" sx={{ flexGrow: 1 }}>
          <Grid>
            <Like post={thread} />
          </Grid>

          <Grid>
            <Button
              className={styles.Thread_ShowCommentButton}
              onClick={showComments === false ? () => handleOnClick(true) : () => handleOnClick(false)}
            >
              <Icon
                style={{ display: `inline-block`, color: `grey` }}
                className={classNames(styles.Thread_CommentIcon, `fal fa-comments`)}
                fontSize="medium"
              />
              <Typography className={styles.Thread_ShowCommentsText}>
                {commentCount > 0 ? postHasCommentsTitle : t('Comment')}
              </Typography>
            </Button>
          </Grid>
        </Grid>

        {showComments &&
          thread.comments.map((comment, index) => {
            return (
              <Grid key={index}>
                <Card className={styles.Thread_Comment}>
                  <GeneralPost post={comment} />
                </Card>
              </Grid>
            )
          })}
        {showComments && (
          <Grid
            container
            className={styles.Thread_CommentField}
            direction="row"
            alignItems="center"
            sx={{ flexGrow: 1 }}
          >
            <BulletinBoardTextField type="comment" ids={[thread.id]} content={thread.comments.length} />
          </Grid>
        )}
      </Card>
    </Grid>
  )
}
